'use strict';

define('vb/private/stateManagement/packagePage',[
  'vb/private/stateManagement/page',
], (Page) => {
  /**
   * PackagePage class
   * A class for page object defined in an app-package
   */
  class PackagePage extends Page {
    constructor(id, parent, requirePath, className = 'PackagePage') {
      super(id, parent, requirePath, className);

      this.package = parent.package;

      /**
       * baseUrl is always relative to the require.baseUrl except when in an app-package.
       * When loading artifacts in an app-package, the require resource need to be prefixed
       * with the app-package base url (something like vx/...)
       */
      this.baseUrl = this.package.baseUrl;

      // app-package redefines this value with the absolute path of the resource in
      // the extension manager.
      this.absoluteUrl = this.package.absoluteUrl;
    }

    descriptorLoader(resourceLocator) {
      return Promise.resolve().then(() => {
        // app-package are using extension with a manifest containering a list of files,
        // so we can check if the file exist before doing a fetch that may fail.
        this.package.checkFileExist(`${this.requirePath}${this.fullName}.json`);
        return super.descriptorLoader(resourceLocator);
      });
    }

    functionsLoader(resourceLocator) {
      return Promise.resolve().then(() => {
        this.package.checkFileExist(`${this.requirePath}${this.fullName}.js`);
        return super.functionsLoader(resourceLocator);
      });
    }

    templateLoader(resourceLocator) {
      return Promise.resolve().then(() => {
        this.package.checkFileExist(`${this.requirePath}${this.fullName}.html`);
        return super.templateLoader(resourceLocator);
      });
    }

    /**
     * Return true if this page can be navigated to from the outside
     * @return {Boolean}
     */
    isNavigable() {
      const { navigation } = this.definition;
      if (navigation && navigation.fromExternal === 'enabled') {
        return true;
      }
      if (this.isDefault() && this.parent.isNavigable()) {
        return true;
      }

      return false;
    }

    /**
     * Check if there is any restriction to navigate to this page
     * @throws an error id the page is not navigable
     */
    checkNavigable() {
      if (!this.isNavigable()) {
        throw new Error(`Navigation to page ${this.getNavPath()} is not enabled.`);
      }
    }
  }

  return PackagePage;
});

